import { StageDataField } from '@Components/Flows';

export function StageContentTypeform({ formData }) {
  return (
    <div className="flex flex-col gap-3">
      {formData?.map((qa, i) => {
        return <StageDataField key={i} label={qa.question} value={qa.answer} />;
      })}
    </div>
  );
}
